import { useMemo } from 'react';
import { useSelectedOrgUnit } from './SelectedOrgUnit';

export const useMyPriceLists = () => {
  const { selectedUserAssortment } = useSelectedOrgUnit();

  const priceListsForDepartment = useMemo(
    () => selectedUserAssortment.priceLists,
    [selectedUserAssortment.priceLists]
  );

  const priceListDraftIdsForDepartment = useMemo(
    () =>
      priceListsForDepartment?.map(
        (priceListsForDepartment) => priceListsForDepartment.draftAssortmentId
      ),
    [priceListsForDepartment]
  );

  return { priceListsForDepartment, priceListDraftIdsForDepartment };
};
